import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import everydaymarketingcampaignApiController from "services/everydaymarketingcampaign.service";
import everydaymarketingcategoryApiController from "services/everydayMarketingcategory.service";
import everydaymarketingtemplateApiController from "services/everydaymarketingtemplate.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import {
  isContentReferenceListRequest,
  normalizeContentReferenceListResponse,
} from "../../services/contentContract";
import { contentErrorMessage } from "./contentError";


export const everydaymarketCategoryViewApi = createAsyncThunk("everydaymarket/everydaymarketlistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await everydaymarketingcategoryApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "everydaymarketview"))
      .catch((error) => HandleError(thunkAPI, error, "everydaymarket/view"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const everydaymarketingcampaignApi = createAsyncThunk("subeverydaymarket/subeverydaymarketlistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await everydaymarketingcampaignApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "subeverydaymarketview"))
      .catch((error) => HandleError(thunkAPI, error, "subeverydaymarket/view"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
export const everydaymarketingtemplateApi = createAsyncThunk("everydaymarkettemplate/everydaymarkettemplatelistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await everydaymarketingtemplateApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "everydaymarkettemplateview"))
      .catch((error) => HandleError(thunkAPI, error, "everydaymarkettemplate/view"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});



const initialState = {
  isTabView: "",
  isOpenEverydaymarketBannerPage: "",
  iseverydaymarketingcategory: [],
  iseverydaymarketingcategoryError: "",
  iseverydaymarketingcampaign: [],
  iseverydaymarketingcampaignError: "",
  iseverydaymarketingtemplate: [],
  iseverydaymarketingtemplateError: "",
  iseverydaymarketsdatas: "",
  issubeverydaymarketsdatas: "",
  isApiStatus: {
    everydaymarketCategoryViewApi: "",
    everydaymarketingcampaignApi: "",
    everydaymarketingtemplateApi: "",
  },
};

const everydaymarketingSlice = createSlice({
  name: "everydaymarketing",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenEverydaymarketBannerPage: (state, action) => {
      state.isOpenEverydaymarketBannerPage = action.payload;
    },
    Getacademydatas: (state, action) => {
      state.iseverydaymarketsdatas = action.payload;
    },
    Getsubacademydatas: (state, action) => {
      state.issubeverydaymarketsdatas = action.payload;
    },
    OpenEveryDayMarketingUpgradeAccountPage: (state = initialState) => {
      state.isOpenAcademyVideoPage = "open";
    },
    CloseEveryDayMarketingUpgradeAccountPage: (state = initialState) => {
      state.isOpenAcademyVideoPage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(everydaymarketCategoryViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketCategoryViewApi: "loading" };
        state.iseverydaymarketingcategoryError = "";
      })
      .addCase(everydaymarketCategoryViewApi.fulfilled, (state, action) => {
        const response = isContentReferenceListRequest(action.meta.arg)
          ? normalizeContentReferenceListResponse(action.payload)
          : action.payload;
        let old_current_page = state.iseverydaymarketingcategory.current_page ? state.iseverydaymarketingcategory.current_page : "";
        let new_current_page = response.current_page ? response.current_page : "";
        let viewdata = state.iseverydaymarketingcategory && state.iseverydaymarketingcategory.data;
        let newviewdata = response && response.data;
        state.iseverydaymarketingcategory = response;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.iseverydaymarketingcategory.data = [...viewdata, ...newviewdata]) : response;
        }
        state.iseverydaymarketingcategoryError = "";
        state.isApiStatus = { ...state.isApiStatus, everydaymarketCategoryViewApi: "succeeded" };
      })
      .addCase(everydaymarketCategoryViewApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketCategoryViewApi: "failed" };
        state.iseverydaymarketingcategoryError = contentErrorMessage(action, "Unable to load everyday campaigns.");
      })
      .addCase(everydaymarketingcampaignApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingcampaignApi: "loading" };
        state.iseverydaymarketingcampaignError = "";
      })
      .addCase(everydaymarketingcampaignApi.fulfilled, (state, action) => {
        const response = isContentReferenceListRequest(action.meta.arg)
          ? normalizeContentReferenceListResponse(action.payload)
          : action.payload;
        let old_current_page = state.iseverydaymarketingcampaign.current_page ? state.iseverydaymarketingcampaign.current_page : "";
        let new_current_page = response.current_page ? response.current_page : "";
        let viewdata = state.iseverydaymarketingcampaign && state.iseverydaymarketingcampaign.data;
        let newviewdata = response && response.data;
        state.iseverydaymarketingcampaign = response;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.iseverydaymarketingcampaign.data = [...viewdata, ...newviewdata]) : response;
        }
        state.iseverydaymarketingcampaignError = "";
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingcampaignApi: "succeeded" };
      })
      .addCase(everydaymarketingcampaignApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingcampaignApi: "failed" };
        state.iseverydaymarketingcampaignError = contentErrorMessage(action, "Unable to load campaign options.");
      })
      .addCase(everydaymarketingtemplateApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingtemplateApi: "loading" };
        state.iseverydaymarketingtemplateError = "";
      })
      .addCase(everydaymarketingtemplateApi.fulfilled, (state, action) => {
        const response = isContentReferenceListRequest(action.meta.arg)
          ? normalizeContentReferenceListResponse(action.payload)
          : action.payload;
        let old_current_page = state.iseverydaymarketingtemplate.current_page ? state.iseverydaymarketingtemplate.current_page : "";
        let new_current_page = response.current_page ? response.current_page : "";
        let viewdata = state.iseverydaymarketingtemplate && state.iseverydaymarketingtemplate.data;
        let newviewdata = response && response.data;
        state.iseverydaymarketingtemplate = response;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.iseverydaymarketingtemplate.data = [...viewdata, ...newviewdata]) : response;
        }
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingtemplateApi: "succeeded" };
        state.iseverydaymarketingtemplateError = "";
      })
      .addCase(everydaymarketingtemplateApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, everydaymarketingtemplateApi: "failed" };
        state.iseverydaymarketingtemplateError = contentErrorMessage(action, "Unable to load marketing templates.");
      });
  },
})



// Action creators are generated for each case reducer function
export const { reset, OpenEverydaymarketBannerPage, Getacademydatas, Getsubacademydatas, OpenEveryDayMarketingUpgradeAccountPage, CloseEveryDayMarketingUpgradeAccountPage } = everydaymarketingSlice.actions;
export default everydaymarketingSlice.reducer;
